import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/notFound',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../components/NotFound.vue')
  }, {
    path: '/:linker',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  }, {
    path: '*',
    component: () => import(/* webpackChunkName: "notFound" */ '../components/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
